import React from "react";
import ResumeTitle from "./ResumeTitle";
import { MdWork } from "react-icons/md";
import { GiGraduateCap } from "react-icons/gi";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <div className="w-full grid grid-cols-9 px-6">
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle title="Experience" icon={<MdWork />} />
        <ResumeCard
          badge=""
          title="Software Engineer"
          subTitle="Capgemini Engineering"
          des="I currently work as a Software Engineer at Capgemini Engineering."
        />
        <ResumeCard
          badge="2024 - 2026"
          title="Programming Teacher"
          subTitle="Happy Code"
          des="I worked as a programming teacher for young talents."
        />
        <ResumeCard
          badge="2023"
          title="Database Operator Intern"
          subTitle="MicroCaos"
          des="I was at MicroCaos as a Database operator, where I learned a lot about Data structure."
        />
      </div>
      <div className="w-full h-full hidden lgl:flex justify-center items-center">
        <span className="w-[1px] h-full bg-zinc-800 inline-flex"></span>
      </div>
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle title="Education" icon={<GiGraduateCap />} />
          <ResumeCard
          badge="2026 - 2028"
          title="Instituto Superior de Tecnologias Avançadas de Lisboa - ISTEC"
          subTitle="Bachelor's Degree in Software Engineering"
          des="I am currently studying Software Engineering at ISTEC."
        />
        <ResumeCard
          badge="2024 - 2026"
          title="Instituto Superior de Tecnologias Avançadas de Lisboa - ISTEC"
          subTitle="Associate Degree in Mobile Development"
          des="I hold a degree in Mobile Device Development."
        />
        <ResumeCard
          badge="2012 - 2020"
          title="CNA BRAZIL"
          subTitle="English Course"
          des="After 8 years I finished the English language course at CNA BRAZIL"
        />
      </div>
    </div>
  );
};

export default Education;
